import React from 'react'
import './App.css'

import { Routes, Route, BrowserRouter as Router } from 'react-router'

import RegisterForm from './domains/forms/Foobara/Commandforge/RegisterForm'
import LoginForm from './domains/forms/Foobara/Auth/LoginForm'
import ApiKeys from './ApiKeys'
import CreateCommandForm from './domains/forms/Foobara/Commandforge/CreateCommandForm'

import Home from './Home'
import Header from './Header'

function App () {
  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create-command" element={<CreateCommandForm />} />
          <Route path="api-keys" element={<ApiKeys />} />
          <Route path="/signup" element={<RegisterForm />} />
          <Route path="/login" element={<LoginForm />} />
        </Routes>
      </Router>
    </div>
  )
}

export default App
